import { useMutation } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { UpdateFranchiseAccount } from '../../../graphql/mutation'
import { GET_FRANCHISE } from '../../../graphql/query'

type Props = {
  data: any
}

const AgreementDetailsPage: React.FC<Props> = ({ data }) => {
  const params = useParams()
  const uuid: any = params.uuid
  const initialAgreementContent = data?.getFranchise?.franchiseAgreements[0]?.content
  const [showSaveButton, setShowSaveButton] = useState(false)
  const [editorHtml, setEditorHtml] = useState<any>(initialAgreementContent)

  const handleEditorChange = (content: any) => {
    console.log('Content was updated:', content)
    setEditorHtml(content)
    setShowSaveButton(true) // Enable save button when content is updated
  }

  useEffect(() => {
    // Disable save button when the component is initially rendered
    setShowSaveButton(false)
  }, [])

  const handleFileUpload = (event: any) => {
    const file = event.target.files[0]
    if (file && file.type === 'text/plain') {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        setEditorHtml(e.target.result)
      }
      reader.readAsText(file)
    } else {
      alert('Please upload a valid .txt file.')
    }
  }

  const [SaveAgreementDetails, { loading }] = useMutation(UpdateFranchiseAccount, {
    refetchQueries: [
      {
        query: GET_FRANCHISE,
        variables: {
          input: {
            franchiseId: parseInt(uuid)
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Franchise'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'Franchise'
      }
    }
  })

  const SaveChanges = async () => {
    try {
      const inputRes = await SaveAgreementDetails({
        variables: {
          input: {
            id: parseInt(uuid),
            agreementContent: editorHtml
          }
        }
      })

      console.log('SaveFormJson Response:', inputRes)

      if (inputRes.data.updateFranchiseAccount.message) {
        toast.success('Successfully updated Agreement')
      } else {
        toast.error('Failed to save changes.')
      }
    } catch (err) {
      toast.error('Sorry! Unexpected Error.')
      console.error(err)
    } finally {
      setShowSaveButton(false) // Disable save button after the save operation is completed
    }
  }

  const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'color',
    'align',
    'script',
    'background',
    'blockquote',
    'code-block',
    'header',
    'indent',
    'list',
    'script'
  ]

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }, { font: [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['link', 'image', 'blockquote', 'code-block'],
      [{ color: [] }, { background: [] }, { align: [] }],
      ['clean']
    ]
  }

  return (
    <div className='card'>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header border-0 pt-5 d-flex align-items-center justify-content-between'>
          <h3 className='card-title'>
            <span className='card-label fw-bolder fs-3 mb-1'>Agreement Details</span>
          </h3>

          <div className='card-toolbar'>
            {!!showSaveButton ? (
              <button
                className='btn btn-sm btn-primary ms-auto me-4'
                onClick={SaveChanges}
                disabled={loading}
              >
                <i className='bi bi-save' /> Save
              </button>
            ) : (
              <button className='btn btn-sm btn-primary ms-auto me-4' disabled>
                <i className='bi bi-save' /> Save
              </button>
            )}

            <label className='btn btn-sm btn-light-primary'>
              Upload Agreement
              <input
                type='file'
                accept='.txt'
                style={{ display: 'none' }}
                onChange={handleFileUpload}
              />
            </label>
          </div>
        </div>

        <div className='card-body p-9'>
          {/* Editor */}
          <ReactQuill
            theme='snow'
            value={editorHtml}
            onChange={handleEditorChange}
            modules={modules}
            formats={formats}
          />
          {/* Editor */}
        </div>
      </div>
    </div>
  )
}

export default AgreementDetailsPage
